export const SET_DARK_THEME = "SET_DARK_THEME";
export const SET_LIGHT_THEME = "SET_LIGHT_THEME";
export const SET_THEME_ERROR = "SET_THEME_ERROR";
